import { Menubar } from 'primereact/menubar';
import { useTranslation } from "react-i18next";
import { GiKimono } from 'react-icons/gi';
import { BsFillFlagFill } from 'react-icons/bs';
import { GrGroup } from 'react-icons/gr';
import { FaGraduationCap } from 'react-icons/fa';
import { useAuth } from './auth/AuthContext';

const Navigation = () => {
    const { t } = useTranslation();
    const { isAdmin } = useAuth();

    const navlist = [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-bar',
            command: () => { window.location.href = '/'; }
        },
        ...(isAdmin ? [{
            label: 'Admin',
            icon: 'pi pi-fw pi-cog',
            command: () => { window.location.href = '/admin'; }
        }] : []),

        {
            label: t('msg.jkaGyms'), icon: 'pi pi-fw pi-home',
            items: [
                {
                    label: t('msg.jkaGymsAffiliate'),
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/gyms'; },
                },
                { separator: true },
                {
                    label: t('msg.jkaAllGymsAffiliateByState'),
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/gymsallstate'; },
                },
                { separator: true },
                {
                    label: t('msg.jkaGymsAffiliateByState'),
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/gymsstate'; },
                },
                { separator: true },
                {
                    label: t('msg.jkaGymsNotAffiliate'),
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/gymsnotaffiliate'; },
                },
            ],
        },

        {
            label: t('msg.jkaAffiliates'), icon: 'pi pi-fw pi-home',
            items: [
                {
                    label: t('msg.jkaAllRegister'), icon: GiKimono,
                    command: () => { window.location.href = '/affiliates'; }
                },
                {
                    label: t('msg.jkaAffiliatesByName'), icon: GiKimono,
                    command: () => { window.location.href = '/affiliatesByName'; }
                },
                {
                    label: t('msg.jkaAffiliatesByJkaId'), icon: GiKimono,
                    command: () => { window.location.href = '/affiliatesByJkaId'; }
                },
                {
                    label: t('msg.jkaAffiliatesByState'), icon: GiKimono,
                    command: () => { window.location.href = '/affiliatesState'; }
                },
                { separator: true },
                {
                    label: t('msg.jkaActiveAssociateAffiliates'), icon: GiKimono,
                    command: () => { window.location.href = '/activeAssociateAffiliates'; }
                },
                { separator: true },
                {
                    label: t('msg.jkaActiveAffiliates'), icon: GiKimono,
                    command: () => { window.location.href = '/activeAffiliates'; }
                },
                { separator: true },
                {
                    label: t('msg.jkaBlackBelts'), icon: GiKimono,
                    command: () => { window.location.href = '/blackbelts'; }
                },
                {
                    label: t('msg.jkaBlackBeltsByName'), icon: GiKimono,
                    command: () => { window.location.href = '/blackbeltsByName'; }
                },
                {
                    label: t('msg.jkaBlackBeltsState'), icon: GiKimono,
                    command: () => { window.location.href = '/blackbeltsState'; }
                },
            ],
        },

        {
            label: t('msg.jkaProfessors'), icon: FaGraduationCap,
            command: () => { window.location.href = '/teachers'; }
        },
        {
            label: t('msg.jkaInstructors'), icon: FaGraduationCap,
            command: () => { window.location.href = '/instructors'; }
        },
        {
            label: t('msg.jkaExaminers'), icon: FaGraduationCap,
            command: () => { window.location.href = '/examiners'; }
        },

        {
            label: t('msg.jkaReferees'), icon: BsFillFlagFill,
            items: [
                {
                    label: 'Maps',
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/maps'; },
                },
                { separator: true },
                {
                    label: 'Todos',
                    icon: 'pi pi-fw pi-home',
                    command: () => { window.location.href = '/judges'; },
                },
            ],
        },

        {
            label: t('msg.jkaShihankai'), icon: GrGroup,
            command: () => { window.location.href = '/shihankai'; }
        },
        {
            label: 'Eventos', icon: 'pi pi-fw pi-calendar',
            command: () => { window.location.href = '/events'; }
        },
        {
            label: 'Taxas', icon: 'pi pi-fw pi-tag',
            command: () => { window.location.href = '/fees'; }
        },

        {
            label: 'Corpo Diretivo', icon: 'pi pi-fw pi-sitemap',
            items: [
                {
                    label: 'Gestões',
                    icon: 'pi pi-fw pi-calendar',
                    command: () => { window.location.href = '/board/terms'; },
                },
                { separator: true },
                {
                    label: 'Cargos',
                    icon: 'pi pi-fw pi-list',
                    command: () => { window.location.href = '/board/positions'; },
                },
            ],
        },
    ];

    return (
        <div>
            <header>
                <nav>
                    <p></p>
                    <Menubar model={navlist} />
                    <p></p>
                </nav>
            </header>
        </div>
    );
};

export default Navigation;
